<template>
  <div class="row container-fluid d-flex justify-content-center m-0 p-0 folioimages">
    <div class="row col-10 bg-dark pt-2 contenuimg">
      <div class="col-12 text-right text-white mb-3 p-0">
        <h3>X</h3>
      </div>
      <div class="col-4 p-0 pr-1">
        <img src="../assets/img/grabu.png" alt="port">
      </div>
      <div class="col-2 p-0 pl-1">
        <div class="col-6 p-0">
          <img src="../assets/img/rex.png" alt="port">
        </div>
        <div class="col-6 p-0">
          <img src="../assets/img/sheya.png" alt="port">
        </div>
        <div class="col-6 p-0">
          <img src="../assets/img/capt.png" alt="port">
        </div>
        <div class="col-6 p-0">
          <img src="../assets/img/flora.png" alt="port">
        </div>
      </div>
      <div class="col-6 m-0 p-0 text-white">
        <h1>Pixel art :</h1>
        <h3>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ab recusandae dolores architecto nulla, consequuntur enim quasi repudiandae explicabo quidem, atque nihil, eaque et itaque autem perferendis velit quae molestias culpa?</h3>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  mounted() {},
  name: "app",
  data() {
    return {};
  }
};
</script>


// WEBPACK FOOTER //
// src/projets/folio.vue